import { styled, Box, Switch } from "@mui/material";
import LangEN from "../../assets/icons/en_flag.svg";
import LangDE from "../../assets/icons/de_flag.svg";

export const LanguageSwitchRoot = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: 10,
  zIndex: 99,
  position: "absolute",
  top: 15,
  right: 15,
}));

export const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 55,
  height: 30,
  padding: 0,
  position: "relative",

  "& .MuiSwitch-thumb": {
    width: 26,
    height: 26,
    borderRadius: "50%",
    boxShadow: "0 0 3px 2px rgba(0,0,0,0.25)",
    backgroundImage: `url(${LangEN})`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },

  "& .MuiSwitch-track": {
    borderRadius: 20,
    backgroundColor: theme?.palette?.companyColors?.accent,
    opacity: 1,
    position: "relative",
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 0,
    top: 2,
    left: 3,
    transition: "transform 300ms ease",
    backgroundColor: theme?.palette?.companyColors?.accent,

    "&.Mui-checked": {
      transform: "translateX(23px)",

      "& .MuiSwitch-thumb": {
        borderRadius: "50%",
        backgroundImage: `url(${LangDE})`,
      },

      "+.MuiSwitch-track": {
        backgroundColor: theme?.palette?.companyColors?.accent,
        opacity: 1,
      },
    },
  },
}));
